function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("0FUnI", function(module, exports) {
    $parcel$export(module.exports, "LockScreenExperimentShared", ()=>$15f7cfbeea6a4a2e$export$9cb33fb0dce2d2e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $h07C2;
    var $7CMCs;
    var $jOWa1;
    var $inMms;
    var $cOXUL;
    var $lpwtK;
    var $8zOmE;
    var $2NMNM;
    var $ldyPw;
    var $k9JTq;
    var $5oBMG;
    var $j6rYQ;
    var $4hWok;
    const $15f7cfbeea6a4a2e$var$LockScreenExperimentSharedComponent = ()=>{
        const isScreenLocked = (0, (0, parcelRequire("jOWa1")).useIsScreenLocked)();
        const [, lockScreenActions] = (0, (0, parcelRequire("jOWa1")).useLockScreenController)();
        const fireFeatureExposed = (0, (0, parcelRequire("4hWok")).useFeatureExposedEvent)();
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const productEntitlementDetails = (0, (0, parcelRequire("5oBMG")).useProductEntitlementDetails)();
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const projectType = (0, (0, parcelRequire("2vSU6")).toProjectType)(project?.type);
        const edition = projectType && (0, (0, parcelRequire("ldyPw")).getEditionForProject)(projectType, appEditions);
        const productKey = projectType && (0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)(projectType);
        const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
        const billingSourceSystem = entitlementDetails?.billingSourceSystem || 'HAMS';
        const entitlementId = entitlementDetails?.entitlementId;
        const { eligible: eligible, ineligibilityReason: ineligibilityReason } = (0, (0, parcelRequire("4hWok")).getLocalEligibility)({
            projectType: projectType,
            edition: edition,
            entitlementDetails: entitlementDetails,
            billingSourceSystem: billingSourceSystem,
            entitlementId: entitlementId
        });
        const prefetchAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                edition: edition,
                productKey: productKey,
                productEntitlementDetails: productEntitlementDetails
            }), [
            edition,
            productKey,
            productEntitlementDetails
        ]);
        const handleLockScreenServiceError = (0, $5uXOq.useCallback)((err)=>{
            if (!(0, (0, parcelRequire("inMms")).isSupportedProjectType)(projectType)) return;
            const error = (0, (0, parcelRequire("4hWok")).transformError)(err);
            fireFeatureExposed('fetchEligibilityFailed', projectType, {
                ...prefetchAnalyticsAttributes,
                error: error
            }, edition);
            lockScreenActions.unlockScreen();
        }, [
            projectType,
            fireFeatureExposed,
            prefetchAnalyticsAttributes,
            edition,
            lockScreenActions
        ]);
        const { loading: loadingLockScreenDetails, data: lockScreenDetails, error: lockScreenDetailsError, fetch: fetchLockScreenDetails } = (0, (0, parcelRequire("j6rYQ")).useLockScreenService)({
            entitlementId: entitlementId,
            onError: handleLockScreenServiceError
        });
        const updateLockScreen = (0, $5uXOq.useCallback)(async (supportedProjectType, projectEdition)=>{
            lockScreenActions.unlockScreen();
            const data = await fetchLockScreenDetails();
            const isOnVariationForTrialEndLockScreen = ()=>{
                const { cohort: cohort } = (0, (0, parcelRequire("inMms")).getStatSigCohortAndExposureFunction)({
                    projectType: supportedProjectType,
                    edition: projectEdition
                });
                return cohort === 'variation';
            };
            if (data) {
                if (!data.predunning) {
                    fireFeatureExposed('notInPreDunning', supportedProjectType, {
                        ...prefetchAnalyticsAttributes,
                        lockScreenDetails: data
                    }, projectEdition);
                    lockScreenActions.unlockScreen();
                } else if (!data.usageOverLimit) {
                    fireFeatureExposed('underUserLimit', supportedProjectType, {
                        ...prefetchAnalyticsAttributes,
                        lockScreenDetails: data
                    }, projectEdition);
                    lockScreenActions.unlockScreen();
                } else {
                    const { isEnrolled: isEndOfTrialMessageExperimentEnrolled, cohort: endOfTrialCohort, fireStatsigExperimentExposure: fireStatsigEotExperimentExposure } = (0, (0, parcelRequire("h07C2")).getEndOfTrialMessageExperiment)(supportedProjectType);
                    if (isEndOfTrialMessageExperimentEnrolled && projectEdition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)) {
                        fireStatsigEotExperimentExposure();
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', 'endOfTrialMessaging', {
                            cohort: endOfTrialCohort,
                            growthInitiative: 'transmuters',
                            projectType: supportedProjectType,
                            edition: projectEdition
                        });
                        if (endOfTrialCohort === 'variation') {
                            fireFeatureExposed('isVariationForEOTModal', supportedProjectType, {
                                ...prefetchAnalyticsAttributes,
                                lockScreenDetails: data
                            }, projectEdition);
                            lockScreenActions.unlockScreen();
                            return;
                        }
                    }
                    fireFeatureExposed(null, supportedProjectType, {
                        ...prefetchAnalyticsAttributes,
                        lockScreenDetails: data
                    }, projectEdition);
                    if (isOnVariationForTrialEndLockScreen()) lockScreenActions.lockScreen();
                    else lockScreenActions.unlockScreen();
                }
            }
        }, [
            lockScreenActions,
            fetchLockScreenDetails,
            fireFeatureExposed,
            prefetchAnalyticsAttributes,
            createAnalyticsEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("inMms")).isSupportedProjectType)(projectType)) lockScreenActions.unlockScreen();
            else if (!(0, (0, parcelRequire("inMms")).isTrialEndLockScreenEnabledForProject)({
                projectType: projectType,
                edition: edition
            })) lockScreenActions.unlockScreen();
            else if (!eligible) {
                fireFeatureExposed(ineligibilityReason, projectType, prefetchAnalyticsAttributes, edition);
                lockScreenActions.unlockScreen();
            } else updateLockScreen(projectType, edition);
        }, [
            projectType,
            eligible,
            ineligibilityReason,
            prefetchAnalyticsAttributes,
            fireFeatureExposed,
            lockScreenActions,
            updateLockScreen,
            edition
        ]);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                ...prefetchAnalyticsAttributes,
                lockScreenDetails: lockScreenDetails
            }), [
            prefetchAnalyticsAttributes,
            lockScreenDetails
        ]);
        if (isScreenLocked) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "lock-screen-experiment-async",
            fallback: "unmount",
            onError: ()=>lockScreenActions.unlockScreen(),
            packageName: (0, $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b),
            teamName: (0, $e113a6ff9475fdf6$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOXUL")).AsyncLazyLockScreenExperiment), {
            showSkeleton: loadingLockScreenDetails,
            showError: !!lockScreenDetailsError,
            predunningDaysLeft: lockScreenDetails?.predunningDaysLeft,
            isBillingAdmin: lockScreenDetails?.isBillingAdmin,
            isBillingUser: lockScreenDetails?.isBillingUser,
            transactionAccountId: lockScreenDetails?.transactionAccountId,
            invoiceGroupId: lockScreenDetails?.invoiceGroupId,
            usageOverLimit: lockScreenDetails?.usageOverLimit,
            entitlementId: entitlementId,
            projectType: projectType,
            analyticsAttributes: analyticsAttributes
        }));
        return null;
    };
    const $15f7cfbeea6a4a2e$export$9cb33fb0dce2d2e3 = ()=>{
        const [, lockScreenActions] = (0, (0, parcelRequire("jOWa1")).useLockScreenController)();
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        if ((0, (0, parcelRequire("inMms")).isTrialEndLockScreenEnabledForAnyProjectType)(appEditions)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "lock-screen-experiment-shared",
            fallback: "unmount",
            onError: ()=>lockScreenActions.unlockScreen(),
            packageName: (0, $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b),
            teamName: (0, $e113a6ff9475fdf6$export$d57b6b390e78d90f)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($15f7cfbeea6a4a2e$var$LockScreenExperimentSharedComponent, null));
        return null;
    };
    $15f7cfbeea6a4a2e$export$9cb33fb0dce2d2e3.displayName = 'LockScreenExperimentShared';
});
parcelRegister("h07C2", function(module, exports) {
    $parcel$export(module.exports, "getEndOfTrialMessageAudience", ()=>$63b65b2214aacc81$export$35c002d8cb752227);
    $parcel$export(module.exports, "getEndOfTrialMessageExperiment", ()=>$63b65b2214aacc81$export$cc0a7ba2b7691053);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2vSU6;
    var $3lmGj;
    var $6s1PB;
    var $bZB1h;
    const $63b65b2214aacc81$export$35c002d8cb752227 = (preDunningDaysLeft, projectType)=>{
        if (preDunningDaysLeft >= 0 && preDunningDaysLeft <= 13) return (0, (0, parcelRequire("bZB1h")).END_OF_TRIAL_MESSAGE_AUDIENCES)[projectType][preDunningDaysLeft];
        return undefined;
    };
    const $63b65b2214aacc81$var$getEndOfTrialMessageExperimentConfig = (projectType)=>{
        if (!(0, (0, parcelRequire("3lmGj")).isSupportedEotmProjectType)(projectType)) throw new Error(`Invalid EOTM projectType: ${projectType}`);
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) {
            const [endOfTrialMessageConfig, fireStatsigExperimentExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('end_of_trial_ep_message_jpd');
            return {
                config: endOfTrialMessageConfig,
                fireStatsigExperimentExposure: fireStatsigExperimentExposure,
                flagKey: 'end_of_trial_ep_message_jpd'
            };
        }
        const [endOfTrialMessageConfig, fireStatsigExperimentExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('end_of_trial_ep_message_jsm');
        return {
            config: endOfTrialMessageConfig,
            fireStatsigExperimentExposure: fireStatsigExperimentExposure,
            flagKey: 'end_of_trial_ep_message_jsm'
        };
    };
    const $63b65b2214aacc81$export$cc0a7ba2b7691053 = (projectType)=>{
        if (!(0, (0, parcelRequire("3lmGj")).isSupportedEotmProjectType)(projectType)) return {
            isEnrolled: false,
            cohort: 'not-enrolled',
            fireStatsigExperimentExposure: (0, ($parcel$interopDefault($8Rkzz)))
        };
        const { config: config, fireStatsigExperimentExposure: fireStatsigExperimentExposure, flagKey: flagKey } = $63b65b2214aacc81$var$getEndOfTrialMessageExperimentConfig(projectType);
        const cohort = config.get('cohort', 'not-enrolled');
        return {
            isEnrolled: cohort !== 'not-enrolled',
            cohort: cohort,
            fireStatsigExperimentExposure: fireStatsigExperimentExposure,
            flagKey: flagKey
        };
    };
});
parcelRegister("3lmGj", function(module, exports) {
    $parcel$export(module.exports, "isSupportedEotmProjectType", ()=>$bbfabfdd0055e6a3$export$177b0b5ff46e69ac);
    var $2vSU6;
    const $bbfabfdd0055e6a3$var$SUPPORTED_EOTM_PROJECT_TYPES = [
        (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT),
        (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)
    ];
    const $bbfabfdd0055e6a3$export$177b0b5ff46e69ac = (value)=>{
        const projectType = (0, (0, parcelRequire("2vSU6")).toProjectType)(value);
        return (!!projectType && $bbfabfdd0055e6a3$var$SUPPORTED_EOTM_PROJECT_TYPES.includes(projectType));
    };
});
parcelRegister("jOWa1", function(module, exports) {
    $parcel$export(module.exports, "useLockScreenController", ()=>$7311a60b2564fbbc$export$e035a0795b3eefc0);
    $parcel$export(module.exports, "useIsScreenLocked", ()=>$7311a60b2564fbbc$export$8a9d757ad1774a77);
    var $lpwtK;
    var $k9JTq;
    var $3sQ5x;
    var $iXqE5;
    var $inMms;
    const $7311a60b2564fbbc$export$111f5c5aa8d2ad30 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isLocked: false
        },
        actions: {
            lockScreen: ()=>({ setState: setState })=>setState({
                        isLocked: true
                    }),
            unlockScreen: ()=>({ setState: setState })=>setState({
                        isLocked: false
                    })
        },
        name: 'LockScreenExperiment'
    });
    const $7311a60b2564fbbc$export$e035a0795b3eefc0 = (0, (0, parcelRequire("3sQ5x")).createHook)($7311a60b2564fbbc$export$111f5c5aa8d2ad30);
    const $7311a60b2564fbbc$export$8a9d757ad1774a77 = ()=>{
        const [lockScreenState] = $7311a60b2564fbbc$export$e035a0795b3eefc0();
        const { loading: loadingProject, data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, (0, parcelRequire("inMms")).isTrialEndLockScreenEnabledForAnyProjectType)(appEditions) && !loadingProject && (0, (0, parcelRequire("inMms")).isSupportedProjectType)(project?.type) && lockScreenState.isLocked;
    };
});
parcelRegister("inMms", function(module, exports) {
    $parcel$export(module.exports, "getStatSigCohortAndExposureFunction", ()=>$a02343de72fbd5a9$export$dcea8823e3724239);
    $parcel$export(module.exports, "isSupportedProjectType", ()=>$a02343de72fbd5a9$export$fa630a47d84fb39a);
    $parcel$export(module.exports, "isTrialEndLockScreenEnabledForProject", ()=>$a02343de72fbd5a9$export$cd0c634567b0c255);
    $parcel$export(module.exports, "isTrialEndLockScreenEnabledForAnyProjectType", ()=>$a02343de72fbd5a9$export$26a64e0070bbd19d);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2vSU6;
    var $6s1PB;
    var $co1wz;
    var $ldyPw;
    const $a02343de72fbd5a9$export$37f449592e04a567 = [
        (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT),
        (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)
    ];
    const $a02343de72fbd5a9$export$dcea8823e3724239 = ({ projectType: projectType, edition: edition })=>{
        let expConfig;
        let fireExpExperimentExposure;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
                if (edition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)) [expConfig, fireExpExperimentExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jpd_trial_end_lock_screen_experiment');
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (edition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)) [expConfig, fireExpExperimentExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jsw_trial_end_lock_screen_experiment');
                break;
            default:
                break;
        }
        return {
            cohort: expConfig ? expConfig.get('cohort', 'not-enrolled') : 'not-enrolled',
            fireExpExperimentExposure: fireExpExperimentExposure ?? (0, ($parcel$interopDefault($8Rkzz)))
        };
    };
    const $a02343de72fbd5a9$export$fa630a47d84fb39a = (value)=>{
        const projectType = (0, (0, parcelRequire("2vSU6")).toProjectType)(value);
        return !!projectType && $a02343de72fbd5a9$export$37f449592e04a567.includes(projectType);
    };
    const $a02343de72fbd5a9$export$cd0c634567b0c255 = ({ projectType: projectType, edition: edition })=>{
        const { cohort: cohort } = $a02343de72fbd5a9$export$dcea8823e3724239({
            projectType: projectType,
            edition: edition
        });
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
                if (edition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)) return true;
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                if (edition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)) return (0, (0, parcelRequire("co1wz")).ff)('jsw-trial-end-lock-screen-experiment_ieq79') && cohort !== 'not-enrolled';
                break;
            default:
                return false;
        }
        return false;
    };
    const $a02343de72fbd5a9$export$26a64e0070bbd19d = (appEditions)=>$a02343de72fbd5a9$export$37f449592e04a567.some((projectType)=>{
            const edition = projectType && appEditions && (0, (0, parcelRequire("ldyPw")).getEditionForProject)(projectType, appEditions);
            return $a02343de72fbd5a9$export$cd0c634567b0c255({
                projectType: projectType,
                edition: edition
            });
        });
});
parcelRegister("cOXUL", function(module, exports) {
    $parcel$export(module.exports, "AsyncLazyLockScreenExperiment", ()=>$3ebfbe78fc0aef45$export$570466d2125f2d64);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $3ebfbe78fc0aef45$var$LazyLockScreenExperiment = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("1YRxH")).then((module)=>module.LockScreenExperiment), {
        moduleId: "./src/packages/growth/end-of-trial/lock-screen-experiment/src/ui/index.tsx"
    });
    const $3ebfbe78fc0aef45$export$570466d2125f2d64 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lock-screen-experiment",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3ebfbe78fc0aef45$var$LazyLockScreenExperiment, props));
});
parcelRegister("1YRxH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7WYXN")
    ]).then(()=>parcelRequire('7HLpT'));
});
const $e113a6ff9475fdf6$export$b8b9d90f9e5bd72b = '@atlassian/jira-lock-screen-experiment-shared';
const $e113a6ff9475fdf6$export$d57b6b390e78d90f = 'transmuters-growth';
parcelRegister("j6rYQ", function(module, exports) {
    $parcel$export(module.exports, "useLockScreenService", ()=>$2e505f0fa422ba23$export$33c585774e52c9a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $ld2hZ;
    var $eusud;
    const $2e505f0fa422ba23$var$fetchLockScreenDetails = async (entitlementId)=>{
        if (!entitlementId) throw new Error('empty entitlementId');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/growth/trial-end-lock-screen/is-locked?entitlementId=${entitlementId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    };
    const $2e505f0fa422ba23$export$33c585774e52c9a2 = ({ entitlementId: entitlementId, onError: onError })=>{
        const request = (0, $5uXOq.useCallback)(async ()=>{
            try {
                const result = await $2e505f0fa422ba23$var$fetchLockScreenDetails(entitlementId);
                return result;
            } catch (err) {
                onError(err);
                throw err;
            }
        }, [
            entitlementId,
            onError
        ]);
        return (0, (0, parcelRequire("ld2hZ")).useService)(request);
    };
});
parcelRegister("4hWok", function(module, exports) {
    $parcel$export(module.exports, "useFeatureExposedEvent", ()=>$56b16374244eb1b9$export$23ce6e1fb2ba7f83);
    $parcel$export(module.exports, "getLocalEligibility", ()=>$56b16374244eb1b9$export$9a41e8e8fae9628d);
    $parcel$export(module.exports, "transformError", ()=>$56b16374244eb1b9$export$78c6267359db7e73);
    var $5uXOq = parcelRequire("5uXOq");
    var $hewIM;
    var $2vSU6;
    var $inMms;
    var $8zOmE;
    var $2NMNM;
    var $ldyPw;
    var $cNd4s;
    const $56b16374244eb1b9$export$23ce6e1fb2ba7f83 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        return (0, $5uXOq.useCallback)((ineligibilityReason, projectType, attributes = {}, edition)=>{
            const { cohort: cohort, fireExpExperimentExposure: fireExpExperimentExposure } = (0, (0, parcelRequire("inMms")).getStatSigCohortAndExposureFunction)({
                projectType: projectType,
                edition: edition
            });
            if (ineligibilityReason === null) {
                fireExpExperimentExposure();
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', 'trialEndLockScreen', {
                    ...ineligibilityReason === null ? {
                        cohort: cohort
                    } : {
                        ineligibilityReason: ineligibilityReason,
                        originalCohort: cohort,
                        cohort: 'not-enrolled'
                    },
                    isSiteAdmin: isSiteAdmin,
                    growthInitiative: 'transmuters',
                    ...attributes
                });
            }
        }, [
            createAnalyticsEvent,
            isSiteAdmin
        ]);
    };
    const $56b16374244eb1b9$export$9a41e8e8fae9628d = ({ projectType: projectType, edition: edition, entitlementDetails: entitlementDetails, billingSourceSystem: billingSourceSystem, entitlementId: entitlementId })=>{
        if (projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) && edition !== (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION) && edition !== (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)) return {
            eligible: false,
            ineligibilityReason: 'invalidSoftwareProjectTypeAndEditionCombo'
        };
        if (projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT) && edition !== (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION)) return {
            eligible: false,
            ineligibilityReason: 'invalidBusinessProjectTypeAndEditionCombo'
        };
        if (projectType !== (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) && projectType !== (0, (0, parcelRequire("2vSU6")).CORE_PROJECT) && edition !== (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)) return {
            eligible: false,
            ineligibilityReason: 'invalidEdition'
        };
        if (!entitlementDetails) return {
            eligible: false,
            ineligibilityReason: 'missingEntitlementDetails'
        };
        if (billingSourceSystem !== 'CCP') return {
            eligible: false,
            ineligibilityReason: 'notCCP'
        };
        if (entitlementDetails?.trialEndTime && (0, (0, parcelRequire("hewIM")).default)(entitlementDetails.trialEndTime)) return {
            eligible: false,
            ineligibilityReason: 'inTrial'
        };
        if (!entitlementId) return {
            eligible: false,
            ineligibilityReason: 'missingEntitlementId'
        };
        return {
            eligible: true,
            ineligibilityReason: ''
        };
    };
    const $56b16374244eb1b9$export$78c6267359db7e73 = (error)=>{
        const errorObject = {};
        Object.getOwnPropertyNames(error).filter((name)=>name !== 'stack').forEach((name)=>{
            if (name === 'cause') errorObject[name] = error[name].message;
            else errorObject[name] = error[name];
        });
        return errorObject;
    };
});
